module.exports = __webpack_public_path__ + "static/media/main idea.255380a6.mp3";